import { render } from "./MRegister.vue?vue&type=template&id=b0632382&scoped=true"
import script from "./MRegister.vue?vue&type=script&lang=js"
export * from "./MRegister.vue?vue&type=script&lang=js"

import "./MRegister.vue?vue&type=style&index=0&id=b0632382&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0632382"]])

export default __exports__